import React from 'react';
import { SessionClock } from './SessionClock';
import { StationTriangle } from './StationTriangle';
const coverage = [{
  label: 'The Bat-Ball-Job Rule',
  body: 'Every player has a bat, a ball or a job: feeder, collector, scorer, umpire or target-setter. Nobody stands and watches.'
}, {
  label: '60 · 75 · 90 minutes',
  body: 'Same five blocks, with the timings already worked out for your slot.'
}, {
  label: 'Soft-ball & hard-ball tracks',
  body: 'Two levels inside the same session, so one plan works for a mixed squad.'
}, {
  label: 'Wet-weather swap',
  body: 'A hall, small-room or damp-outfield version of every session. Rain doesn’t cancel training.'
}, {
  label: 'Coach + helpers',
  body: 'You run the session, parent helpers supervise the stations, and every plan says how many adults it needs.'
}, {
  label: 'Minimal kit',
  body: 'Bats, soft balls, stumps and cones. Every session lists exactly what to bring.'
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full border-y-4 border-clay bg-field" data-id="element-269" data-mp="1azwckrmrbcqi">
      <div className="mx-auto max-w-6xl px-5 py-16 text-center sm:py-20" data-id="element-270" data-mp="1f1hl60s9d4uw">
        <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-willow" data-id="element-271" data-mp="1jsr82tmf9u33">The system</p>
        <h2 id="mechanism-heading" className="mt-3 font-display text-3xl text-cream sm:text-5xl" data-id="element-272" data-mp="1osvrosimn4xj">
          The No-Queue Session System
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-cream/80 sm:text-lg" data-id="element-273" data-mp="s3wi9a6b3x3r">
          More drills don&apos;t fix the queue. The problem was never a lack of
          drills: it&apos;s one net, one batter and ten kids waiting. Every
          No-Queue session splits the squad into three stations (batting,
          bowling and fielding) that rotate on one signal, so every player has a
          bat, a ball or a job the whole session. Open the volume, pick the
          session, set the cones.
        </p>

        <div className="mx-auto mt-10 grid max-w-5xl gap-4 lg:grid-cols-[1.15fr_.85fr]" data-id="element-274" data-mp="2hiukmyzxzm7h">
          <SessionClock data-id="element-275" data-mp="1ruytxlr446xt" />
          <StationTriangle data-id="element-276" data-mp="1mu1cxchu9ixw" />
        </div>

        <ul className="mx-auto mt-6 grid max-w-5xl gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-277" data-mp="1mszq6argn80c">
          {coverage.map(item => <li key={item.label} className="rounded-lg border border-field-line bg-cream/5 px-4 py-3" data-id="element-278" data-mp="21opcyb4gzp64">
              <span className="block text-[11px] font-semibold uppercase tracking-widest text-willow" data-id="element-279" data-mp="192e4yfejalza">{item.label}</span>
              <span className="mt-1 block text-sm text-cream/85" data-id="element-280" data-mp="143teh7p33go1">{item.body}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}